import { titleCase } from '@/lib/utils'

import type { EvalCaseAssertionSeverity } from '../../types'

export function formatSeverity(value: EvalCaseAssertionSeverity): string {
  return titleCase(value)
}

export function severityClassName(value: EvalCaseAssertionSeverity): string {
  if (value === 'required') {
    return 'border-error-ui-border bg-error-ui-bg text-error-solid'
  }
  if (value === 'important') {
    return 'border-warning/30 bg-warning/10 text-warning'
  }
  return 'border-primary-ui-border bg-primary-ui-bg text-primary-solid'
}

export const ASSERTION_SEVERITIES: EvalCaseAssertionSeverity[] = [
  'required',
  'important',
  'informational',
]

// Segmented-control styling: the active severity is colour-coded; the rest stay
// neutral. Mirrors the severity palette used by the read-mode badge.
export function severitySegClassName(
  value: EvalCaseAssertionSeverity,
  active: boolean
): string {
  if (!active) {
    return 'border-(--neutral-ui-border) bg-white text-neutral-low-contrast'
  }
  if (value === 'required') {
    return 'border-error-ui-border bg-error-ui-bg text-error-solid'
  }
  if (value === 'important') {
    return 'border-warning/30 bg-warning/10 text-warning'
  }
  // Informational matches the read-mode badge palette.
  return 'border-primary-ui-border bg-primary-ui-bg text-primary-solid'
}
